import { HelperResult, ResumeFile } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useGetResumeApprenticeshipFile } = getCRUDHooks({
  entityName: 'resumeApprenticeship',
  get: ({ userId }: { userId: number }): HelperResult<ResumeFile> =>
    clientApi.getOCClient().helpers.user.users.id(userId).resumeApprenticeship.get(),
});

export default useGetResumeApprenticeshipFile;
